export default __webpack_public_path__ + "static/media/Liang-Yu.d7251b2b.png";